import { useQuery } from '@tanstack/react-query';

import { configs } from '@hero/configs';

import * as merchantServices from '../../services';

export const useGetMerchant = (params, options) =>
  useQuery(['merchant', configs.merchantName], () => merchantServices.getMerchant(params), options);
